module.exports = __webpack_public_path__ + "img/deco-corner-right-bottom.18cda24.png";